// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__4-wjj","modal":"Modal_modal__Wrc1O","slide-down":"Modal_slide-down__4DeaD"};